(function () {
  var HIDE_DELAY = 280;
  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
  var hideTimer = null;
  var openMenuId = null;

  function getHeaderGroup() {
    return document.querySelector('.shopify-section-group-header-group');
  }

  function getHeaderBottomEl() {
    return (
      document.querySelector('#header-component') ||
      document.querySelector('.shopify-section-group-header-group .header-section') ||
      getHeaderGroup()
    );
  }

  function getMenusRoot() {
    return document.querySelector('[data-wd-header-menus]');
  }

  function getWrap() {
    return document.querySelector('[data-wd-header-nav-wrap]');
  }

  function getPanel(menuId) {
    return document.querySelector('[data-wd-menu-panel="' + menuId + '"]');
  }

  function getTrigger(menuId) {
    return document.querySelector('[data-wd-menu-id="' + menuId + '"] .wd-header-nav__link');
  }

  function cancelClose() {
    window.clearTimeout(hideTimer);
    hideTimer = null;
  }

  function isOverOpenUi(node) {
    if (!node || !node.closest) return false;
    return !!(
      node.closest('[data-wd-header-menus]') ||
      node.closest('[data-wd-header-nav-wrap]') ||
      node.closest('[data-wd-dropdown]')
    );
  }

  function scheduleClose() {
    cancelClose();
    hideTimer = window.setTimeout(function () {
      hideTimer = null;
      var menus = getMenusRoot();
      var wrap = getWrap();
      if ((menus && menus.matches(':hover')) || (wrap && wrap.matches(':hover'))) return;
      closeAll();
    }, HIDE_DELAY);
  }

  /* Escape header stacking/contain — append to body so sheet can receive pointer events. */
  function ensureMenusPortal() {
    var menus = getMenusRoot();
    if (!menus) return null;
    if (menus.parentElement !== document.body) {
      document.body.appendChild(menus);
    }
    bindMenusRoot(menus);
    return menus;
  }

  function syncHeaderBottom() {
    var headerEl = getHeaderBottomEl();
    var menus = ensureMenusPortal();
    var wrap = getWrap();
    if (!headerEl || !menus) return;
    var top = Math.round(headerEl.getBoundingClientRect().bottom);
    menus.style.setProperty('--wd-header-bottom', top + 'px');
    if (wrap) wrap.style.setProperty('--wd-header-bottom', top + 'px');
    document.documentElement.style.setProperty('--wd-header-bottom', top + 'px');
  }

  function positionPopover(menuId) {
    var panel = getPanel(menuId);
    var trigger = getTrigger(menuId);
    var menus = getMenusRoot();
    if (!panel || !trigger || !menus) return;

    var triggerRect = trigger.getBoundingClientRect();
    var menusRect = menus.getBoundingClientRect();
    var popover = panel.querySelector('.wd-header-menu__popover');
    if (!popover) return;

    /* Pin top to white tab bottom — no gap over the hero */
    var top = Math.round(triggerRect.bottom - menusRect.top) - 1;
    if (top < 0) top = 0;

    var width = Math.max(popover.offsetWidth || 180, Math.ceil(triggerRect.width));
    popover.style.minWidth = Math.ceil(triggerRect.width) + 'px';
    /* Align to left edge of tab (not centered) so panel continues the pill */
    var left = Math.round(triggerRect.left);
    left = Math.max(12, Math.min(left, window.innerWidth - width - 12));

    panel.style.setProperty('--wd-popover-top', top + 'px');
    panel.style.setProperty('--wd-popover-left', left + 'px');
  }

  function activatePane(panel, tabId) {
    if (!panel || !tabId) return;
    panel.querySelectorAll('[data-menu-panel-tab]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-menu-panel-tab') === tabId);
    });
    panel.querySelectorAll('[data-menu-pane]').forEach(function (pane) {
      var match = pane.getAttribute('data-menu-pane') === tabId;
      pane.classList.toggle('is-active', match);
      pane.hidden = !match;
    });
  }

  function bindSidebarTabs(panel) {
    if (panel.__wdSidebarBound) return;
    panel.__wdSidebarBound = true;
    var sidebar = panel.querySelector('[data-wd-menu-sidebar]');
    if (!sidebar) return;

    sidebar.querySelectorAll('[data-menu-panel-tab]').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        activatePane(panel, btn.getAttribute('data-menu-panel-tab'));
      });
      btn.addEventListener('focus', function () {
        activatePane(panel, btn.getAttribute('data-menu-panel-tab'));
      });
      btn.addEventListener('click', function (event) {
        var href = btn.getAttribute('href');
        if (href && href !== '#' && href.indexOf('javascript:') !== 0) {
          return;
        }
        event.preventDefault();
        activatePane(panel, btn.getAttribute('data-menu-panel-tab'));
      });
    });
  }

  function bindMenusRoot(menus) {
    if (!menus || menus.__wdMenusRootBound) return;
    menus.__wdMenusRootBound = true;

    menus.addEventListener('mouseenter', function () {
      if (!DESKTOP_MQ.matches) return;
      cancelClose();
    });

    menus.addEventListener('mouseleave', function (event) {
      if (!DESKTOP_MQ.matches) return;
      if (isOverOpenUi(event.relatedTarget)) {
        cancelClose();
        return;
      }
      scheduleClose();
    });
  }

  function closeAll() {
    var wrap = getWrap();
    var menusRoot = getMenusRoot();
    var header = getHeaderGroup();
    cancelClose();
    openMenuId = null;

    if (wrap) wrap.classList.remove('is-menu-open');
    if (header) header.classList.remove('is-wd-menu-open');
    document.body.classList.remove('wd-mega-menu-open');

    if (menusRoot) {
      menusRoot.hidden = true;
      menusRoot.classList.remove('is-open', 'is-visible');
      menusRoot.style.pointerEvents = 'none';
      menusRoot.querySelectorAll('[data-wd-menu-panel]').forEach(function (panel) {
        panel.hidden = true;
        panel.classList.remove('is-visible');
      });
    }

    document.querySelectorAll('[data-wd-dropdown].is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('.wd-header-nav__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openMenu(menuId) {
    var wrap = getWrap();
    var menusRoot = ensureMenusPortal();
    var item = document.querySelector('[data-wd-menu-id="' + menuId + '"]');
    var panel = getPanel(menuId);
    var trigger = getTrigger(menuId);
    var header = getHeaderGroup();
    if (!wrap || !menusRoot || !item || !panel || !trigger) return;

    cancelClose();

    /* Already open — don't rebuild (mouseover fires often) */
    if (openMenuId === menuId && item.classList.contains('is-open') && !panel.hidden) {
      return;
    }

    document.querySelectorAll('[data-wd-dropdown].is-open').forEach(function (other) {
      if (other === item) return;
      other.classList.remove('is-open');
      var otherTrigger = other.querySelector('.wd-header-nav__link');
      if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
    });
    menusRoot.querySelectorAll('[data-wd-menu-panel]').forEach(function (otherPanel) {
      if (otherPanel === panel) return;
      otherPanel.hidden = true;
      otherPanel.classList.remove('is-visible');
    });

    syncHeaderBottom();

    openMenuId = menuId;
    wrap.classList.add('is-menu-open');
    if (header) header.classList.add('is-wd-menu-open');
    document.body.classList.add('wd-mega-menu-open');

    menusRoot.hidden = false;
    menusRoot.classList.add('is-open');
    menusRoot.style.pointerEvents = 'auto';

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;

    if (panel.classList.contains('wd-header-menu--sheet')) {
      bindSidebarTabs(panel);
    }
    if (panel.classList.contains('wd-header-menu--popover')) {
      positionPopover(menuId);
    }

    requestAnimationFrame(function () {
      menusRoot.classList.add('is-visible');
      panel.classList.add('is-visible');
    });
  }

  function bindDropdownItem(item) {
    if (item.__wdMenuBound) return;
    item.__wdMenuBound = true;

    var menuId = item.getAttribute('data-wd-menu-id');
    var panel = getPanel(menuId);
    var trigger = item.querySelector('.wd-header-nav__link');
    if (!menuId || !panel || !trigger) return;

    ensureMenusPortal();

    if (panel.classList.contains('wd-header-menu--sheet')) {
      bindSidebarTabs(panel);
    }

    function handleOpen() {
      if (!DESKTOP_MQ.matches) return;
      openMenu(menuId);
    }

    /* mouseover bubbles — more reliable than mouseenter when switching tabs quickly */
    item.addEventListener('mouseover', handleOpen);
    item.addEventListener('mouseleave', function (event) {
      if (!DESKTOP_MQ.matches) return;
      if (isOverOpenUi(event.relatedTarget)) {
        cancelClose();
        return;
      }
      scheduleClose();
    });

    trigger.addEventListener('focus', handleOpen);
    item.addEventListener('focusout', function (event) {
      if (!DESKTOP_MQ.matches) return;
      if (isOverOpenUi(event.relatedTarget)) return;
      scheduleClose();
    });

    panel.querySelectorAll('[data-wd-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        closeAll();
        trigger.focus();
      });
    });
  }

  /* If anything overlays a tab, still switch via hit-test under the cursor */
  function bindNavHitSwitch() {
    if (document.documentElement.__wdNavHitSwitchBound) return;
    document.documentElement.__wdNavHitSwitchBound = true;

    document.addEventListener(
      'mousemove',
      function (event) {
        if (!openMenuId || !DESKTOP_MQ.matches) return;
        var stack = document.elementsFromPoint(event.clientX, event.clientY);
        for (var i = 0; i < stack.length; i++) {
          var node = stack[i];
          if (!node || !node.closest) continue;
          var item = node.closest('[data-wd-dropdown]');
          if (!item) continue;
          var id = item.getAttribute('data-wd-menu-id');
          if (id && id !== openMenuId) openMenu(id);
          else cancelClose();
          return;
        }
      },
      { passive: true }
    );
  }

  function bindMobileAccordion(scope) {
    (scope || document).querySelectorAll('[data-wd-drawer-accordion]').forEach(function (details) {
      if (details.__wdAccordionBound) return;
      details.__wdAccordionBound = true;
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        var parent = details.closest('.menu-drawer__menu');
        if (!parent) return;
        parent.querySelectorAll('[data-wd-drawer-accordion]').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });
  }

  function init(scope) {
    ensureMenusPortal();
    syncHeaderBottom();
    bindNavHitSwitch();
    (scope || document).querySelectorAll('[data-wd-dropdown]').forEach(bindDropdownItem);
    bindMobileAccordion(scope);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener(
    'resize',
    function () {
      syncHeaderBottom();
      if (!openMenuId) return;
      var panel = getPanel(openMenuId);
      if (panel && panel.classList.contains('wd-header-menu--popover')) {
        positionPopover(openMenuId);
      }
    },
    { passive: true }
  );

  window.addEventListener('scroll', syncHeaderBottom, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
